import { useEffect, useState } from "react";
import { TIMSCRIBE_ENABLED } from "@/components/timscribe/shared";

const NAV = [
    { href: "/#timbot", label: "AGENT_001", testid: "nav-agent" },
    { href: "/#robotics", label: "ROBOTICS", testid: "nav-robotics" },
    { href: "/#experiments", label: "EXPERIMENTS", testid: "nav-experiments" },
    { href: "/#philosophy", label: "PHILOSOPHY", testid: "nav-philosophy" },
    { href: "/#telemetry", label: "TELEMETRY", testid: "nav-telemetry" },
    { href: "/#funding", label: "FUNDING", testid: "nav-funding" },
    { href: "/blog/search-is-not-evidence", label: "FIELD_REPORTS", testid: "nav-blog" },
    { href: "/#structure", label: "PERSONNEL", testid: "nav-personnel" },
    ...(TIMSCRIBE_ENABLED ? [{ href: "/timscribe", label: "TIMSCRIBE", testid: "nav-timscribe" }] : []),
];

function useBrisbaneTime() {
    const [time, setTime] = useState("--:--:--");
    useEffect(() => {
        const fmt = new Intl.DateTimeFormat("en-AU", {
            timeZone: "Australia/Brisbane",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
        const tick = () => setTime(fmt.format(new Date()));
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, []);
    return time;
}

export default function Header() {
    const time = useBrisbaneTime();
    return (
        <header className="sticky top-0 z-50 backdrop-blur-md bg-[#f2f4f6]/90 border-b border-subtle">
            <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-6">
                <div className="flex items-center space-x-3 shrink-0">
                    <div className="h-3 w-3 bg-cyan-400 rounded-full animate-status" data-testid="header-status-led" />
                    <a
                        href="/#hero"
                        data-testid="site-logo"
                        className="font-mono text-sm tracking-widest font-bold text-cyan-700"
                    >
                        TIMBOTIC<span className="text-cyan-600/60">//LAB.SYS</span>
                    </a>
                </div>
                <nav className="hidden lg:flex items-center gap-x-4 xl:gap-x-6 font-mono text-[11px] xl:text-xs tracking-wider text-slate-500 whitespace-nowrap">
                    {NAV.map((n) => (
                        <a
                            key={n.href}
                            href={n.href}
                            data-testid={n.testid}
                            className="hover:text-cyan-700 transition-colors"
                        >
                            {n.label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center space-x-3 shrink-0">
                    <span
                        data-testid="brisbane-clock"
                        className="font-mono text-[11px] px-2.5 py-1 rounded border border-cyan-500/30 bg-cyan-100/70 text-cyan-700 whitespace-nowrap"
                    >
                        BRISBANE // {time}
                    </span>
                </div>
            </div>
        </header>
    );
}
